<template>
  <v-app id="folder">
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog_upload" persistent max-width="600px">
          <v-card style="background-color: #424242">
            <v-card-title>
              <span class="text-h5">Upload Form</span>
            </v-card-title>
            <v-card-text>
              <v-container>

                <v-row dense>
                  <v-col cols="12">
                    <template>
                      <Small>Click in empty field to select file</Small>
                      <v-file-input
                        ref="fileinput"
                        dark
                        class="white-icon-file-input"
                        prepend-icon="$pdfIcon"
                        v-model="fileselected"
                        accept="*.pdf"
                        label="Locate File"
                        @change="on_file_selected"
                        hint="Click in empty field"
                      ></v-file-input>
                    </template>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="white"
                      readonly
                      v-model="file_item.folder_name"
                      label="Folder Name"
                      required
                      counter="60"
                    ></v-text-field>
                  </v-col>
                  </v-row>

                  <v-row dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="white"
                      maxlength="200"
                      v-model="file_item.filetitle"
                      label="File Title"
                      required
                      counter="200"
                      hint="People see this name"
                    ></v-text-field>
                  </v-col>
                 </v-row>
              
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="white"
                      maxlength="500"
                      v-model="file_item.keywords"
                      label="Keywords"
                      required
                      counter="500"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" @click="submitFile">
                Submit Form
              </v-btn>
              <v-btn color="blue darken-1" text @click="close_upload_now">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-container id="docname_container" class="mt-4">
      <v-row
        ><v-col cols="12">
          <v-btn style="background-color: #616161" @click="backtofolders"
            ><v-icon color="white">$arrowLeft</v-icon> Back to Sections</v-btn
          >
        </v-col>
      </v-row>
      <v-row id="folder_name">
        <v-col
          cols="12"
          class="name-upload mb-4 d-flex flex-column justify-center align-items-flex-start"
        >
          <h3 class="mb-2">SECTION: {{ folder_name }}</h3>
          <v-btn
            style="background-color: #616161"
            @click="show_upload_now"
            v-if="admin"
            >UPLOAD</v-btn
          >
        </v-col>
      </v-row>

      <files :files_update="files_update" :folder_name="folder_name"></files>
    </v-container>
  </v-app>
</template>

<style lang="scss" scoped>
/* 0 media q */
@media (min-width: 0px) {
  /* Target both prepend icon and clear icon dynamically */
  ::v-deep(.white-icon-file-input .v-input__prepend-outer .v-icon),
  ::v-deep(.white-icon-file-input .v-input__icon--clear .v-icon) {
    color: white !important;
  }
  #folder {
    width: 96%;
    margin: 0 auto;
    // margin-top: 67px;
  }

  #folder:deep.theme--light.v-application {
    background: none;
  }

  #folder:deep .v-application--wrap {
    /* min-height: 100vh !important; */
    min-height: auto;
  }

  .name-upload .v-btn {
    width: 25%;
  }

  /* roster logs names */
  .docname_expansion {
    height: 48px;
    width: 100%;
    margin: 0 auto;
    background-color: #708e92;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  .exp-panel-wrap:deep .v-expansion-panel-content__wrap {
    padding: 0;
  }

  .docname_expansion p {
    font-size: 0.9375rem;
  }

  .roster-toolbar {
    height: 30px !important;
  }

  .single-name {
    border-bottom: 2px solid #0000001f;
  }

  .list-docname hr {
    margin-top: 20px;
    border-color: #0000001f;
  }

  /* End roster names */
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import files from "./files.vue";
const MAX_FILE_SIZE = 209715200; // 200 MB

export default {
  name: "folder",
  components: { files },
  mixins: [bus_common],
  props: ["folder_name"],
  data() {
    return {
      files_update: new Date(),
      fileselected: null,
      dialog_upload: false,
      file_item: {
        filename: "",
        folder_name: "",
        filetitle: "",
        keywords: "",
      },
      file_item_new: {
        filename: "",
        folder_name: "",
        filetitle: "",
        keywords: "",
      },
      file_item_dev: {
        filename: "",
        folder_name: "",
        filetitle: "",
        keywords: "",
      },
      items_templates: [
        { name: "Template 1" },
        { name: "Template 2" },
        { name: "Template 3" },
        { name: "Template 4" },
        { name: "Template 5" },
        { name: "Template 6" },
      ],

      items_files: [
        { name: "File 1" },
        { name: "File 2" },
        { name: "File 3" },
        { name: "File 4" },
        { name: "File 5" },
        { name: "File 6" },
      ],

      editedIndex_docname: -1,
      editedItem_docname: {
        name: "",
      },
      defaultItem_docname: {
        name: "",
      },
    };
  },
  computed: {
    admin() {
      return this.$store.state.user.roles.indexOf("forms-admin") > -1;
    },
  },

  /* METHODS */
  methods: {
    backtofolders() {
      this.$emit("backtofolders");
    },
    on_file_selected() {
      setTimeout(() => {
        if (!this.file_item) {
          this.fileselected = null;
          this.$refs.fileinput.reset();
          return;
        }

        //this.fileselected = file; // Allow the valid file through
        this.file_item.filename = this.fileselected.name;
      }, 500);
    },
    close_upload_now() {
      this.file_item.folder_name = this.folder_name;
      this.dialog_upload = false;
    },
    show_upload_now() {
      this.file_item = this.mno(this.file_item_dev);
      this.file_item.folder_name = this.folder_name;
      this.dialog_upload = true;
    },
    submitFile() {
      console.log("wtf max: " + this.fileselected.size);
      if (this.fileselected.size > MAX_FILE_SIZE) {
        this.fileselected = null;
        this.swall_it(
          "File Too Large",
          "The maximum file size is 200 MB. This file cannot be uploaded. Please have the file's author reduce or optimize its size. If this is a PDF, Adobe Acrobat Pro has an optimized PDF feature that may be invoked for this purpose.",
          "warning",
          null,
          null
        );
        this.fileselected = null;
        this.$refs.fileinput.reset();
        return true;
      }
      this.show_loader(true);

      if (this.fileselected == null) {
        this.swall_it(
          "Error Upload File",
          "No file Selected",
          "warning",
          null,
          null
        );

        // this.mrbreakpoint("max");

        this.show_loader(false);
        return true;
      }

      let formData = new FormData();
      formData.append("file", this.fileselected);

      formData.append("email", this.$store.state.user.email);
      formData.append("filename", this.file_item.filename);
      formData.append("filetitle", this.file_item.filetitle);
      formData.append("folder_name", this.file_item.folder_name);
      formData.append("keywords", this.file_item.keywords);
      //     this.$refs.file.value = null;
      this.show_loader(true);
      this.$store
        .dispatch("uploadfile", formData)
        .then((data) => {
          let fileName = data;
          this.dialog_upload = false;
          this.fileselected = null;
          this.files_update = new Date();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Upload File", msg, "error", null, null);
        });
    },
    upload_emit() {
      var form = { filename: "testfile", keyword: "cool beans" };
      this.$emit("upload_emit", form);
    },
    message1() {
      alert("This button opens a window to upload a file");
    },

    message2() {
      alert("Clicking here opens the template.");
    },

    message3() {
      alert("Clicking here opens the file");
    },
  },
};
</script>
